import React from 'react'

import {
  classnames,
  Radio,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string, func } from 'prop-types'

function OneTimeOption({
  selected,
  onSelect: handleSelect,
  price = null,
  originalPrice = null,
  hasDiscount = false,
}) {
  const optionClass = classnames(
    'subscription-purchase__option',
    'subscription-purchase__option--onetime',
    selected && 'subscription-purchase__option--selected'
  )

  return (
    <div
      className={optionClass}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleSelect()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="subscription-purchase__option-radio">
        <Radio
          name="purchaseOption"
          isChecked={selected}
          onChange={handleSelect}
          className="subscription-purchase__radio"
        />
      </div>

      <div className="subscription-purchase__option-content">
        <div className="subscription-purchase__option-header">
          <span className="subscription-purchase__option-title">One-time purchase</span>
          <div className="subscription-purchase__option-price">
            {hasDiscount && (
              <span className="subscription-purchase__original-price">{originalPrice}</span>
            )}
            <span className="subscription-purchase__current-price">{price}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

OneTimeOption.propTypes = {
  selected: bool.isRequired,
  onSelect: func.isRequired,
  price: string,
  originalPrice: string,
  hasDiscount: bool,
}

export default OneTimeOption
